import {getBottomLayerHeaderTmpl} from "./html.template";

export const getBottomLayerSwiperTmpl = (className) => `
  <div class="swiper-container ${className}">
    <ul class="swiper-wrapper">
    </ul>
  </div>
`;

// FETASK-1181 | 230718 | subTitle 추가
export const getBottomLayerSpinnerTmpl = (type, title, subTitle) => `
  <div class="popup-dialog ui-popup ui-bottom" data-type="${type}" style="display: none">
        <div class="popup-section">
            <div class="popup-group">
                ${!!title ? getBottomLayerHeaderTmpl(title, subTitle) : ''}
                <div class="popup-content">
                    <div class="group-spinner">
                    </div>
                </div>
                <div class="popup-footer">
                  <div class="component-btn">
                    <div class="btn-group">
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
`;

// CHPFMTASK-2128
export const getBottomLayerSpinnerTmplTab = (type, title, subTitle) => `
  <div class="popup-dialog ui-popup ui-bottom" data-type="${type}" style="display: none">
        <div class="popup-section">
            <div class="popup-group">
                ${!!title ? getBottomLayerHeaderTmpl(title, subTitle) : ''}
                <div class="popup-content">
                  <div class="toggle-radio-area ui-ToggleRadio" data-mapping="true" style="margin-bottom:48px;padding:0 2rem;">
                    <div class="toggle-list-col">
                      <div class="move-item" aria-hidden="true"></div>
                      <!-- 매달 -->
                      <div class="toggle-item active">
                        <input type="radio" id="dst1" name="datespinnerTab" checked>
                        <a class="toggle-link" href="#none" role="button" title="매달">
                          <span class="txt">매달</span>
                          <span class="hide-txt" aria-hidden="true">선택됨</span>
                        </a>
                      </div>
                      <!-- 매주 -->
                      <div class="toggle-item">
                        <input type="radio" id="dst2" name="datespinnerTab">
                        <a class="toggle-link" href="#none" role="button" title="매주">
                          <span class="txt">매주</span>
                        </a>
                      </div>
                      <!-- 매일 -->
                      <div class="toggle-item">
                        <input type="radio" id="dst3" name="datespinnerTab">
                        <a class="toggle-link" href="#none" role="button" title="매일">
                          <span class="txt">매일</span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <!-- 매달 -->
                  <div class="group-spinner">
                   
                  </div>
                </div>
                <div class="popup-footer">
                  <div class="component-btn">
                    <div class="btn-group">
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
`;

// select : 일반옵션 타입
export const getBottomLayerSelectItemTmpl = (value = '', selected = '', disabled = '', text = '', link) => `
  <li class="select-item">
    <button class="btn-option ${selected}" type="button" data-val="${value}" ${(!!link) ? `data-link="${link}"` : ''} ${disabled}>${text}</button>
  </li>
`;

export const getBottomLayerListTmpl = (value = '', selected = '', disabled = '', text = '', link) => `
  <li class="swiper-slide">
    <button class="btn-option ${selected}" type="button" data-val="${value}" ${(!!link) ? `data-link="${link}"` : ''} ${disabled}>${text}</button>
  </li>
`;

export const getBottomLayerCountListTmpl = (btnCancel = "", btnConfirm = "") => `
${btnCancel && `
<button type="button" class="btn-lv01 divider-gray ui-btnCancel">
  <span class="txt">${btnCancel}</span>
</button>
`}
${btnConfirm && `
<button type="button" class="btn-lv01 primary1 ui-btnConfirm">
  <span class="txt">${btnConfirm}</span>
</button>
`}
`;
